import React from "react";
import AppBar from "@material-ui/core/AppBar";
import { Toolbar, IconButton } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/core/styles";
import { Redirect, withRouter } from "react-router-dom";
import { compose } from "recompose";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import appConstants from "../../../appConstants";
import styles from "../headerStyles";
import ParameterListener from "../Parameters";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import Tooltip from "../../common/StyledToolTip";

const ShipmentSelectionTabs = {
  shipmentSelection: {
    label: "Shipment Selection",
    id: "shipmentSelectionHeader",
    path: appConstants.NAV_URLS.SHIPMENT_SELECTION,
  },
};

class ShipmentSelectionHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTabValue: this.props.path
        ? this.props.path.url.toLowerCase()
        : false,
    };
  }

  handleChange = (event, value) => {
    this.setState({
      currentTabValue: value,
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        {this.state.currentTabValue &&
          this.state.currentTabValue != this.props.path.url && (
            <Redirect to={this.state.currentTabValue} push />
          )}
        <AppBar
          position="sticky"
          className="appHeader"
          classes={{ root: classes.headerStyles }}
        >
          <Toolbar variant="dense" classes={{ gutters: classes.gutters }}>
            <img
              className={classes.shipmentSelectionRmaxLogo}
              src="../../images/RouteMax_Logo_Orange_v2.svg"
            />
            <Tabs
              value={
                [ShipmentSelectionTabs.shipmentSelection.path].includes(
                  this.state.currentTabValue
                )
                  ? this.state.currentTabValue
                  : false
              }
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator,
              }}
              onChange={this.handleChange}
            >
              <Tab
                value={ShipmentSelectionTabs.shipmentSelection.path}
                label={ShipmentSelectionTabs.shipmentSelection.label}
                id={ShipmentSelectionTabs.shipmentSelection.id}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
            </Tabs>
            <div className={classes.grow}></div>
            <div className={classes.headerIcons}></div>
            <div
              className={`${classes.muiIconContainer} ${classes.headerIconStyles}`}
            >
              <IconButton
                color="inherit"
                className={classes.muiIconButtonStyle}
                onClick={(e) => this.handleChange(e, "/settings")}
                data-automationid="settings-icon"
              >
                <Tooltip title="Application Settings">
                  <SettingsIcon />
                </Tooltip>
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <ParameterListener
          scenarioId={this.props.userData.userProfile.scenarioID}
        />
      </div>
    );
  }
}
export default compose(
  withStyles(styles),
  withRouter,
  withUserProfile
)(ShipmentSelectionHeader);
